// extracted by mini-css-extract-plugin
module.exports = {"wallet_container":"Wallet_wallet_container__MvIub","wallet":"Wallet_wallet__qFDuc","highlight_name":"Wallet_highlight_name__Hmh10","icn_external":"Wallet_icn_external___jwnR"};